module.exports = __webpack_public_path__ + "static/logo-2ada959112c9fe379f46c808cb1f5a12.svg";